import { render, staticRenderFns } from "./deletePhotoIcon.vue?vue&type=template&id=16869500&scoped=true"
import script from "./deletePhotoIcon.vue?vue&type=script&lang=js"
export * from "./deletePhotoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16869500",
  null
  
)

export default component.exports